<template>
  <div id="app">
    <HomeM v-if="isMobile"/>
    <Home v-else/>
  </div>
</template>

<script>
import Home from './views/home.vue'
import HomeM from './views/home_m.vue'
export default {
  name: 'App',
  components: {
    Home,
    HomeM
  },
  data () {
    return {
      isMobile: false
    }
  },
  methods: {
    isMobileDevice() {
      return /Mobile|Android/i.test(navigator.userAgent);
    }
  },
  mounted () {
    this.isMobile = this.isMobileDevice()
    // 统计
    this.$axios.get('https://financehd.cctv.cn/finance/user/index/run/rd/10019?pagenumber=2')
  }
}
</script>

<style>
</style>
